import styled from "styled-components";
import { type FontSizeProps, type DisplayProps, type SpaceProps, color, space } from "styled-system";
import type { ThemeTypedColorProps } from "../../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Text = styled.div<
    { lineThrough?: boolean; isLarge?: boolean; isSmall?: boolean } & ThemeTypedColorProps &
        FontSizeProps &
        DisplayProps &
        SpaceProps
>`
    display: inline-block;
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${theme.colors.midnight};
    ${space};
    ${color};
`;

export const MonthlyRateItems = styled.ul`
    display: flex;
    flex-direction: column;
    padding: 0;
`;

export const MonthlyRateItem = styled.li`
    display: flex;
    margin-bottom: 0;
`;
